import { useSelector } from "react-redux";
import { numberTdStyle } from "../../../ProjectPDF";

const FinancialSummary = () => {
  const signing_date = useSelector(
    (state: any) => state.projectInfo?.basicInfo?.signing_date,
  );
  const { financialStatus, adpShare, donorFund } = useSelector(
    (state: any) => state?.projectInfo,
  );

  return (
    <>
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Total Funds Allocated</th>
              <th>Donor Funds</th>
              <th>Local Funds PSDP / ADP</th>
              <th>Additional Financing</th>
              <th>Project Approval Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={numberTdStyle}>
                {adpShare +
                  donorFund +
                  (financialStatus.additional_financing || 0)}
              </td>
              <td style={numberTdStyle}>{donorFund}</td>
              <td style={numberTdStyle}>{adpShare}</td>
              <td style={numberTdStyle}>
                {financialStatus.additional_financing || 0}
              </td>
              <td style={numberTdStyle}>{signing_date}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default FinancialSummary;
